// Framework and third-party non-ui
import React, { Component } from "react";

// Redux operations and local helpers/utils/modules
import Rdx from "../../../redux/Rdx";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";
import * as queryUtil from "../../base/queryUtil";
import Context from "../../../context/Context";
import QueryCriteria from "../../base/QueryCriteria";

// Component specific modules (Component-styled, etc.)
import { ListItem, EmptyAlert } from "../../styles/Common/list";

// App components
import Button from "../../../common/components/Button";

// Third-party components (buttons, icons, etc.)
import { CalciteH5 } from "calcite-react/Elements";
import Skeleton from "react-loading-skeleton";
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";

// JSON

// CSS

export default class Items extends Component {
  _activePromise;
  _mounted = false;

  preferSkeleton = false;

  constructor(props) {
    super(props);
    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 120,
    });
    this.state = component.newState({
      exceededTransferLimit: false,
      featureCount: 0,
      featureItems: null,
      isWorking: true,
      searchText: "",
      wasMore: false,
      wasMorePosition: 0,
      preserveScroll: false,
    });
    this.moreClicked = this.moreClicked.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.queryFeatures();

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, (params) => {
        let actions = this.props.requeryOnPlanActions;
        if (actions && actions.indexOf(params.action) !== -1) {
          if (this._mounted) {
            this.setState({ isWorking: true, preserveScroll: true });
            this.setRdxFeatureItems([]);
            this.queryFeatures(false, true);
          }
        }
      }),

      Topic.subscribe(Topic.QueryCriteriaChanged, (params) => {
        const queryCriteriaKey = this.props.queryCriteriaKey;
        if (queryCriteriaKey && queryCriteriaKey === params.key) {
          if (this._mounted) {
            this.setState({ isWorking: true, preserveScroll: false });
            this.setRdxFeatureItems([]);
            this.queryFeatures(false);
          }
        }
      }),
    ]);
  }

  componentDidUpdate = () => {
    if (!this.props.disableForceUpdate || this.state.featureCount === 0) {
      this.cache.clearAll();
      this._list.forceUpdateGrid();
    }
  };

  componentWillUnmount() {
    this.setRdxFeatureItems([]);
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  getQueryCriteria() {
    return QueryCriteria.get(this.props.queryCriteriaKey);
  }

  getSource() {
    return this.getQueryCriteria().getSource();
  }

  moreClicked(event) {
    if (this.state.isWorking) return;
    this.setState({
      isWorking: true,
      preserveScroll: true,
      wasMorePosition: this.state.featureCount,
      wasMore: true
    });
    this.queryFeatures(true);
  }

  publishListInfo(isRefreshing, count, totalCount) {
    const queryCriteriaKey = this.props.queryCriteriaKey;
    Topic.publish(Topic.ListCountInfo, {
      queryCriteriaKey,
      isRefreshing,
      count,
      totalCount,
    });
  }

  publishWorking(isWorking) {
    this.publishListInfo(isWorking);
  }

  queryFeatures(isMore, preserveScroll) {
    isMore = !!isMore;
    const source = this.getSource();
    if (!source) {
      this.setState({ isWorking: false });
      this.publishWorking(false);
      return;
    }
    this.publishWorking(true);

    const lastFeatureCount = this.state.featureCount;
    const queryCriteria = this.getQueryCriteria();
    const orderByFields = queryCriteria.makeOrderByFields();
    const where = queryCriteria.getWhere();
    let options = {
      source,
      isMore,
      lastFeatureCount,
      orderByFields,
      where,
      queryCriteria,
    };

    const p1 = queryUtil.queryCount(options);
    const p2 = queryUtil.queryFeatures(options);
    const promise = (this._activePromise = Promise.all([p1, p2]));
    promise
      .then((results) => {
        if (!this._mounted) return;
        if (promise !== this._activePromise) return;
        this._activePromise = null;
        const countResult = results[0];
        const result = results[1];
        if (result && result.features) {
          const resultInfo = queryUtil.makeResultInfo(source, result);
          let featureItems = resultInfo.featureItems;
          let featureCount = featureItems.length;
          let totalCount = countResult;
          if (isMore) {
            const prevFeatureItems = this.state.featureItems;
            if (prevFeatureItems && prevFeatureItems.length > 0) {
              featureItems = prevFeatureItems.concat(featureItems);
              featureCount = featureItems.length;
            }
          }

          this.setState((state) => {
            return {
              exceededTransferLimit: result.exceededTransferLimit,
              featureCount: featureCount,
              featureItems: featureItems,
              isWorking: false,
              wasMore: isMore,
              preserveScroll: preserveScroll,
            };
          });
          this.setRdxFeatureItems(featureItems);
          this.publishListInfo(false, featureCount, totalCount);
        } else {
          if (isMore) {
            // TODO?????
          } else {
            this.setState((state) => {
              return {
                exceededTransferLimit: false,
                isWorking: false,
                featureCount: 0,
                featureItems: [],
                wasMore: false,
                preserveScroll: false,
              };
            });
            this.setRdxFeatureItems([]);
            this.publishListInfo(false, 0, 0);
          }
        }
      })
      .catch((ex) => {
        console.warn("Error querying features:");
        console.error(ex);
        if (!this._mounted) return;
        if (promise !== this._activePromise) return;
        this._activePromise = null;
        this.setState({ isWorking: false });
        this.publishWorking(false);
        Topic.publishErrorAccessingData();
      });
  }

  _setRef = (ref) => {
    this._list = ref;
  };

  render() {
    const {
      featureItems,
      isWorking,
      preserveScroll,
      exceededTransferLimit,
      wasMorePosition,
      wasMore
    } = this.state;
    const listItems = [];
    let scrollToIndex;

    if (featureItems) {
      featureItems.forEach((featureItem, index) => {
        listItems.push(featureItem);
      });
    }

    if (isWorking && !preserveScroll) {
      if (this.preferSkeleton) {
        listItems.length = 0;
        listItems.push("__skeleton__");
      }
      scrollToIndex = 0;
    } else if (!featureItems || featureItems.length === 0) {
      if (!isWorking) listItems.push("__empty__");
    } else {
      if (exceededTransferLimit) {
        listItems.push("__more__");
      }
    }

    if (wasMore) {
      scrollToIndex = wasMorePosition - 1;
    }

    return (
      <div style={{ flexGrow: 1 }}>
        <AutoSizer>
          {({ width, height }) => {
            return (
              <List
                ref={this._setRef}
                estimatedRowSize={120}
                width={width}
                height={height}
                rowRenderer={this.renderRow}
                rowCount={listItems.length}
                deferredMeasurementCache={this.cache}
                rowHeight={this.cache.rowHeight}
                overscanRowCount={3}
                scrollToIndex={scrollToIndex}
              />
            );
          }}
        </AutoSizer>
      </div>
    );
  }

  renderRow = ({ index, key, style, parent, isScrolling }) => {
    const { featureItems, isWorking, preserveScroll } = this.state;
    const { renderItem } = this.props;
    const featureItem = (featureItems && featureItems[index]) || null;
    style = {
      ...style,
      margin: "4px 0",
    };

    let row;
    if (isWorking && !preserveScroll) {
      if (this.preferSkeleton) {
        row = <Skeleton count={15} />;
      } else {
        if (featureItem) {
          row = renderItem(this.getSource(), featureItem, index);
        } else if (featureItems.length === index) {
          //row = (<Skeleton count={15} />);
          row = <div></div>;
        }
      }
    } else if (!featureItems || featureItems.length === 0) {
      row = this.renderEmptyList();
    } else {
      if (featureItem) {
        row = renderItem(this.getSource(), featureItem, index);
      } else if (featureItems.length === index) {
        if (this.state.exceededTransferLimit) {
          row = this.renderMore();
        }
      }
    }

    return (
      <CellMeasurer
        key={key}
        cache={this.cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <div style={style}>{row}</div>
      </CellMeasurer>
    );
  };

  renderItem(source, featureItem, index) {
    if (typeof this.props.renderItem === "function") {
      return this.props.renderItem(source, featureItem, index);
    }
    const key = featureItem.key;
    return <ListItem key={key}>{key}</ListItem>;
  }

  renderMore() {
    const i18n = Context.instance.i18n;
    return (
      <ListItem key={"more"} moreButton>
        <Button onClick={this.moreClicked}>{i18n.general.more}</Button>
      </ListItem>
    );
  }

  renderEmptyList() {
    const i18n = Context.instance.i18n;
    const msg = (this.props.noResultsMessage || i18n.messages.noResults);
    return (
      <EmptyAlert key="noResults">
        <CalciteH5>{msg}</CalciteH5>
      </EmptyAlert>
    );
  }

  setRdxFeatureItems(featureItems) {
    const rdxFeatureItemsKey = this.props.rdxFeatureItemsKey;
    if (rdxFeatureItemsKey) {
      Rdx.setValue(null, rdxFeatureItemsKey, featureItems);
    }
  }
}
